module.exports = __webpack_public_path__ + "static/media/canada3.36dccb1b.jpg";